import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

export default function About() {
  return (
    <main className="about-page" style={{ paddingTop: '60px' }}>
      <section className="about-hero">
        <div className="container">
          <div className="about-badge">About Us</div>
          <h1>The Story Behind <span className="accent">WhiteScreen</span></h1>
          <p>A free, powerful, and privacy-first tool trusted by millions of creators, students, developers, and professionals worldwide.</p>
        </div>
      </section>
      <div className="container about-content">
        <div className="about-grid">
          <div className="about-main">
            <section className="about-sec">
              <h2>Our Mission</h2>
              <p>WhiteScreen was built on a simple idea: your display is one of the most powerful and underutilized tools you own. A single, well-designed web tool should be able to transform it into a professional-grade lightbox, a monitor testing instrument, a video production backdrop, a focus environment, or a light therapy surface — instantly, for free, on any device, without installing anything.</p>
              <p>We've spent years refining every feature based on real user feedback from artists, teachers, photographers, developers, medical professionals, and everyday users who found unexpected value in a tool that sounds, on the surface, almost absurdly simple. That simplicity is the point.</p>
            </section>
            <section className="about-sec">
              <h2>What We Offer</h2>
              <div className="offer-grid">
                {[
                  { icon: '⬜', title: 'White Screen', desc: 'The original — pure white for lightbox use, monitor cleaning, and focus.', link: '/' },
                  { icon: '⬛', title: 'Black Screen', desc: 'OLED power saving, dead pixel testing, privacy mode, and dark room use.', link: '/black-screen' },
                  { icon: '🟥', title: 'Red Screen', desc: 'Night vision preservation, astrophotography, and darkroom workflows.', link: '/red-screen' },
                  { icon: '🟩', title: 'Green Screen', desc: 'Chroma key compositing, video production, and sub-pixel diagnostics.', link: '/green-screen' },
                  { icon: '🟦', title: 'Blue Screen', desc: 'Blue sub-pixel testing, circadian light therapy, and video backdrops.', link: '/blue-screen' },
                  { icon: '🟨', title: 'Yellow Screen', desc: 'Warm reading mode, peak brightness display, and energy-boosting ambience.', link: '/yellow-screen' },
                  { icon: '🟪', title: 'Purple Screen', desc: 'Creative backdrops, luxury brand work, and relaxation environments.', link: '/purple-screen' },
                  { icon: '🟧', title: 'Orange Screen', desc: 'Blue-light-free evening use, golden-hour photography, and energy environments.', link: '/orange-screen' },
                  { icon: '🩷', title: 'Pink Screen', desc: 'Beauty photography, fashion branding, and calming wellness environments.', link: '/pink-screen' },
                  { icon: '🔊', title: 'White Noise', desc: 'Focus, sleep, and relaxation with ambient sound and noise presets.', link: '/white-noise' },
                ].map((item, i) => (
                  <Link key={i} to={item.link} className="offer-card">
                    <span className="offer-icon">{item.icon}</span>
                    <div>
                      <div className="offer-title">{item.title}</div>
                      <div className="offer-desc">{item.desc}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </section>
            <section className="about-sec">
              <h2>Privacy Commitment</h2>
              <p>WhiteScreen processes everything locally in your browser. We don't log your color choices, your screen sessions, your audio preferences, or any personally identifiable information. The fullscreen API request we make is a temporary display permission that expires the moment you exit fullscreen. No account required, no cookies for tracking, no advertising pixels.</p>
              <p>You can verify our network behavior by opening browser developer tools (F12) and checking the Network tab while using any tool on the site — you'll find zero user-tracking requests generated by tool interactions.</p>
            </section>
          </div>
          <aside className="about-sidebar">
            <div className="sidebar-card">
              <h4>Quick Stats</h4>
              <ul className="stats-list">
                <li><span>🌍</span> Available in 40+ languages</li>
                <li><span>📱</span> Works on all devices</li>
                <li><span>🎨</span> 9 color screens + noise</li>
                <li><span>🔒</span> Zero data collection</li>
                <li><span>💸</span> 100% free forever</li>
                <li><span>⚡</span> No installation needed</li>
                <li><span>👥</span> 2M+ monthly users</li>
              </ul>
            </div>
            <div className="sidebar-card accent-card">
              <h4>Get in Touch</h4>
              <p>Have feedback, a feature request, or found a bug? We read every message.</p>
              <Link to="/contact" className="cta-btn">Contact Us →</Link>
            </div>
          </aside>
        </div>
      </div>
    </main>
  );
}
